import { Modal } from '@sc/shared-ui';
import { ReactElement } from 'react';

interface Props {
  open: boolean; 
  onClose: () => void; 
}

export const PersonalityModal = ({
  open,
  onClose
}: Props): ReactElement => 
(
    <Modal title="Chat Personality" open={open} onClose={onClose}>
      <h1>Personality</h1>
    </Modal>
  );